module.exports = __webpack_public_path__ + "img/humertomansilla.dfb9ab92.jpg";